export function formatChangedLineValue(event) {
  if (event.target.type === 'checkbox') {
    return !this.props.obj[event.target.name];
  } else if (['syllables', 'stresses'].indexOf(event.target.name) >= 0) {
    return parseInt(event.target.value, 10) || null;
  } else if (event.target.name === 'text') {
    return event.target.value.replace(/(\r\n|\n|\r)/gm, '');
  }
  return event.target.value;
}



// WEBPACK FOOTER //
// ./src/utils/lines.js